/* eslint-disable */

function JSEnhancer() {
    /** Prep Static Functions **/
    JSEnhancer.enhance = function (element) {
        if (element) {
            Object.assign(element, JSEnhancer.prototype);
        }
        return element;
    };

    JSEnhancer.prototype.jsAppend = function (tagName) {
        const me = this;
        let child;
        if (isSVGElement(tagName)) {
            child = document.createElementNS('http://www.w3.org/2000/svg', tagName);
        } else {
            child = document.createElement(tagName);
        }
        JSEnhancer.enhance(child);

        this.appendChild(child);
        return child;

        // Inner functions
        // Either the tag itself is SVG, or it's parent (this) is an SVG element
        function isSVGElement(tagName) {
            const isIt = tagName.toUpperCase() == 'SVG' || me instanceof SVGElement;
            return isIt;
        }
    };

    JSEnhancer.prototype.jsStyle = function (styleMap) {
        const keys = Object.keys(styleMap);
        for (const key of keys) {
            this.style[key] = styleMap[key];
        }
        return this;
    };

    JSEnhancer.prototype.jsAttr = function (attrMap) {
        const keys = Object.keys(attrMap);
        for (const key of keys) {
            this.setAttribute(key, attrMap[key]);
        }
        return this;
    };

    JSEnhancer.prototype.jsAddEventListener = function (eventName, callBack, useCapture) {
        this.addEventListener(eventName, callBack, useCapture);
        return this;
    };

    JSEnhancer.prototype.jsRemoveEventListener = function (eventName, callBack, useCapture) {
        this.removeEventListener(eventName, callBack, useCapture);
        return this;
    };

    JSEnhancer.prototype.jsAddClass = function () {
        try {
            // If the user gives bad dataList (eg. empty string) don't overreact, stay cool
            const styleModuleObject = arguments[0];
            if (typeof styleModuleObject === 'string') {
                // This means we're in sandbox
                this.classList.add(...arguments);
            } else {
                // this means we're using css modules
                let className;
                for (let i = 1; i < arguments.length; i++) {
                    className = arguments[i];
                    this.classList.add(styleModuleObject[className]);
                }
            }
        } catch (e) {}

        return this;
    };

    JSEnhancer.prototype.jsRemoveClass = function () {
        try {
            // If the user gives bad dataList (eg. empty string) don't overreact, stay cool
            this.classList.remove(...arguments);
        } catch (e) {}

        return this;
    };

    JSEnhancer.prototype.jsRemoveMe = function () {
        let parentNode = this.parentNode;
        if (parentNode) {
            parentNode.removeChild(this);
        }
    };

    JSEnhancer.prototype.jsRemoveChildren = function () {
        while (this.firstChild) {
            this.firstChild.jsRemoveMe();
        }
    };

    JSEnhancer.prototype.jsText = function (textContent) {
        this.textContent = textContent;
        return this;
    };

    JSEnhancer.prototype.jsSetData = function (dataObject) {
        this.__data__ = dataObject;
        return this;
    };

    JSEnhancer.prototype.jsGetData = function () {
        return this.__data__;
    };

    JSEnhancer.prototype.jsForceStyleRecalc = function () {
        let computedStyle = window.getComputedStyle(this);
        return computedStyle.transform;
    };
}

JSEnhancer.getInstance = function () {
    if (!JSEnhancer.instance) {
        JSEnhancer.instance = new JSEnhancer();
    }
    return JSEnhancer.instance;
};

JSEnhancer.getInstance();
